module.exports = __webpack_public_path__ + "img/xlsx2.6aa351d1.png";